import { A } from '@adornis/base/env-info.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';

@Entity()
export class Suspension extends AdornisEntity {
  static override _class = 'Suspension';

  @validate(nonOptional())
  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => String)
  message!: string;

  @validate(nonOptional())
  @Field(type => String)
  institutionID!: string;

  @validate(options => {
    if (options.target.blockedTill) return;
    if (!options.value) throw new ValidationError('Pflichtfeld', { key: options.key });
  })
  @Field(type => Boolean)
  blockedNoLimit!: boolean;

  @validate(options => {
    if (typeof options.target.blockedNoLimit === 'boolean' || options.target.blockedNoLimit) return;
    if (!options.value) throw new ValidationError('Pflichtfeld', { key: options.key });
  })
  @Field(type => DateTime)
  blockedTill!: DateTime;
}
